import { InstitutionInterestView } from "@bitwarden/web-vault/app/models/view/institution/institution-interest.view";

export function _getAppliedInterest(
  rates: InstitutionInterestView[],
  amount: number,
): InstitutionInterestView {
  const sortedRates = rates.sort((a, b) => a.range - b.range);

  for (const rate of sortedRates) {
    if (amount <= rate.range) {
      return rate;
    }
  }
  return sortedRates.find((rate) => rate.range === -1);
}

/**
 * "Bank : Account" for a best-scenario account, or just the account's name: accountBank is optional
 * (#4112), and a blank or whitespace-only one mustn't leave a stray " : " in front of the name.
 * One rule for the carousel and both wizard steps. A missing name reads as "", as the templates'
 * interpolation used to show it, not "undefined".
 */
export function accountLabel(
  accountBank: string | undefined,
  accountName: string | undefined,
): string {
  const bank = accountBank?.trim();
  const name = accountName ?? "";
  return bank ? `${bank} : ${name}` : name;
}
